import { observable, action } from "mobx";
import { ApiService, ApiUrl, Enum, Constants } from "helpers";
import Alert from 'react-s-alert';
import { automationStore } from "stores";
import { AutomationType, AutomationTypeText } from "helpers/enum";
const lookupStore = observable(
  {
    currentWorkTypes: [],
    //sources: [],
    ratings: [],
    candidateStatuses: [],
    salutations: [],
    candidateNoteStatuses: [],
    candidateCustomFields: [],
    clientStatuses: [],
    clientNoteStatuses: [],
    clientCustomFields: [],
    placementCustomFields: [],
    jobCustomFields: [],
    applicationCustomFields: [],
    jobSources: [],
    emailTemplateList: [],
    candidateEmailTemplateList: [],
    clientEmailTemplateList: [],
    emailCampaignLink: [],
    surveyList: [],
    surveyListWithDetails: [],
    formList: [],
    activeFormList: [],
    textCampaignList: [],
    countries: [],
    tagSuggestions: [],
    customFields: [],
    emailLinkClickedList: [],
    smsLinkClickedList: [],
    placementStatuses: [],
    placementTypes: [],
    interviewTypes: [],
    jobTypes: [],
    jobs: [],
    jobLocations: [],
    applicationStatuses: [],
    jobStatuses: [],
    candidateAttachmentCategories: [],
    candidateAttachmentCategoriesDefaults: { defaultCategory: null, fallbackCategory: null },
    contactAttachmentCategories: [],
    contactAttachmentCategoriesDefaults: { defaultCategory: null, fallbackCategory: null },
    candidateSkillsHierarchy: [],
    skillCategories: [],
    skillSubCategories: [],
    skills: [],
    candidateCurrentPositions: [],
    candidateCurrentEmployers: [],
    candidatePostalCodes: [],
    candidateCities: [],
    candidateStates: [],
    candidateSources: [],
    candidateContactMethods: [],
    clientPositions: [],
    clientCities: [],
    clientStates: [],
    clientPostalCodes: [],
    clientCountries: [],
    clientCompanies: [],

    resetWorkTypes() {
      this.currentWorkTypes = [];
    },

    // resetSources() {
    //   this.sources = [];
    // },

    resetRatings() {
      this.ratings = [];
    },

    resetCandidateStatuses() {
      this.candidateStatuses = [];
    },

    resetCountries() {
      this.countries = [];
    },

    resetAll() {
      this.resetWorkTypes();
      //this.resetSources();
      this.resetRatings();
      this.resetCandidateStatuses();
      this.resetCountries();
    },

    getAll() {
      this.getCurrentWorkTypes();
      //this.getSources();
      this.getRatings();
      this.getCandidateStatuses();
      this.getClientStatuses();
    },

    setCurrentWorkTypes(currentWorkTypes) {
      this.currentWorkTypes = [...currentWorkTypes];
    },

    setCustomFields(customFields) {
      this.customFields = [...customFields];
    },

    // setSources(sources) {
    //   this.sources = [...sources];
    // },

    setRatings(ratings) {
      this.ratings = [...ratings];
    },

    setSalutations(salutations) {
      this.salutations = [...salutations];
    },

    setCandidateStatuses(candidateStatuses) {
      this.candidateStatuses = [...candidateStatuses];
    },

    setCandidateNoteStatuses(candidateNoteStatuses) {
      this.candidateNoteStatuses = [...candidateNoteStatuses];
    },

    setCandidateCustomFields(candidateCustomFields) {
      this.candidateCustomFields = [...candidateCustomFields];
    },

    setClientStatuses(clientStatuses) {
      this.clientStatuses = [...clientStatuses];
    },

    setClientNoteStatuses(clientNoteStatuses) {
      this.clientNoteStatuses = [...clientNoteStatuses];
    },

    setClientCustomFields(clientCustomFields) {
      this.clientCustomFields = [...clientCustomFields];
    },

    setPlacementCustomFields(placementCustomFields) {
      this.placementCustomFields = [...placementCustomFields];
    },

    setJobCustomFields(jobCustomFields) {
      this.jobCustomFields = [...jobCustomFields];
    },

    setApplicationCustomFields(applicationCustomFields) {
      this.applicationCustomFields = [...applicationCustomFields];
    },

    setEmailTemplateList(emailTemplateList) {
      this.emailTemplateList = [];
      this.emailTemplateList = [...emailTemplateList];
    },

    setCandidateEmailTemplateList(candidateEmailTemplateList) {
      this.candidateEmailTemplateList = [];
      this.candidateEmailTemplateList = [...candidateEmailTemplateList];
    },

    setClientEmailTemplateList(clientEmailTemplateList) {
      this.clientEmailTemplateList = [];
      this.clientEmailTemplateList = [...clientEmailTemplateList];
    },

    setEmailCampaignLinks(emailCampaignLink) {
      this.emailCampaignLink = [];
      this.emailCampaignLink = [...emailCampaignLink]
    },

    setSurveyList(surveyList) {
      this.surveyList = [];
      this.surveyList = [...surveyList];
    },

    setSurveyListWithDetails(surveyListWithDetails) {
      this.surveyListWithDetails = [];
      this.surveyListWithDetails = [...surveyListWithDetails];
    },

    setFormList(formList) {
      this.formList = [];
      this.formList = [...formList];
    },

    setActiveFormList(activeFormList) {
      this.activeFormList = [];
      this.activeFormList = [...activeFormList];
    },

    setTextCampaignList(textCampaignList) {
      this.textCampaignList = [];
      this.textCampaignList = [...textCampaignList];
    },

    setCountries(countries) {
      this.countries = [...countries];
    },

    setTagSuggestions(tagSuggestions) {
      this.tagSuggestions = [];
      this.tagSuggestions = [
        ...tagSuggestions
      ];
    },

    setJobSources(jobSources) {
      this.jobSources = [];
      this.jobSources = [
        ...jobSources
      ];
    },

    setPlacementStatuses(placementStatuses) {
      this.placementStatuses = [];
      this.placementStatuses = [
        ...placementStatuses
      ];
    },

    setPlacementTypes(placementTypes) {
      this.placementTypes = [];
      this.placementTypes = [
        ...placementTypes
      ];
    },

    setInterviewTypes(interviewTypes) {
      this.interviewTypes = [];
      this.interviewTypes = [
        ...interviewTypes
      ];
    },

    setJobTypes(jobTypes) {
      this.jobTypes = [];
      this.jobTypes = [
        ...jobTypes
      ];
    },

    setJobs(jobs) {
      this.jobs = [];
      this.jobs = [
        ...jobs
      ];
    },

    setJobLocations(jobLocations) {
      this.jobLocations = [];
      this.jobLocations = [
        ...(jobLocations || [])
      ];
    },

    setApplicationStatuses(applicationStatuses) {
      this.applicationStatuses = [];
      this.applicationStatuses = [
        ...applicationStatuses
      ];
    },

    setJobStatuses(jobStatuses) {
      this.jobStatuses = [];
      this.jobStatuses = [
        ...jobStatuses
      ];
    },

    setCandidateAttachmentCategories(candidateAttachmentCategories) {
      this.candidateAttachmentCategories = candidateAttachmentCategories;
    },

    setCandidateAttachmentCategoriesDefaults(defaults) {
      this.candidateAttachmentCategoriesDefaults = defaults || { defaultCategory: null, fallbackCategory: null };
    },

    setContactAttachmentCategories(contactAttachmentCategories) {
      this.contactAttachmentCategories = contactAttachmentCategories;
    },

    setContactAttachmentCategoriesDefaults(defaults) {
      this.contactAttachmentCategoriesDefaults = defaults || { defaultCategory: null, fallbackCategory: null };
    },

    // #region Skills setters
    setCandidateSkillsHierarchy(candidateSkillsHierarchy) {
      this.candidateSkillsHierarchy = [...candidateSkillsHierarchy];
    },

    setSkillCategories(skillCategories) {
      this.skillCategories = [...skillCategories];
    },

    setSkillSubCategories(skillSubCategories) {
      this.skillSubCategories = [...skillSubCategories];
    },

    setSkills(skills) {
      this.skills = [...skills];
    },
    // #endregion

    // #region Candidate location/position setters
    setCandidateCurrentPositions(currentPositions) {
      this.candidateCurrentPositions = [...currentPositions];
    },

    setCandidateCurrentEmployers(currentEmployers) {
      this.candidateCurrentEmployers = [...currentEmployers];
    },

    setCandidatePostalCodes(postalCodes) {
      this.candidatePostalCodes = [...postalCodes];
    },

    setCandidateCities(cities) {
      this.candidateCities = [...cities];
    },

    setCandidateStates(states) {
      this.candidateStates = [...states];
    },

    setCandidateSources(sources) {
      this.candidateSources = [...sources];
    },

    setCandidateContactMethods(contactMethods) {
      this.candidateContactMethods = [...contactMethods];
    },

    setClientPositions(positions) {
      this.clientPositions = [...positions];
    },

    setClientCities(cities) {
      this.clientCities = [...cities];
    },

    setClientStates(states) {
      this.clientStates = [...states];
    },

    setClientPostalCodes(postalCodes) {
      this.clientPostalCodes = [...postalCodes];
    },

    setClientCountries(countries) {
      this.clientCountries = [...countries];
    },

    setClientCompanies(companies) {
      this.clientCompanies = [...companies];
    },
    // #endregion

    getBaitLink(data) {
      return (ApiService.getDetailWithParams(ApiUrl.getBaitlink, '', data).then(
        action(
          response => {
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    setEmailLinkClickedList(emailLinkClicked) {
      this.emailLinkClickedList = [];
      this.emailLinkClickedList = [...emailLinkClicked];
    },

    setSmsLinkClickedList(smsLinkClicked) {
      this.smsLinkClickedList = [];
      this.smsLinkClickedList = [...smsLinkClicked];
    },

    getCurrentWorkTypes() {
      return (ApiService.get(ApiUrl.getJAWorkTypes).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // TODO HERE if something necessary, for now just return data exactly from API
              this.setCurrentWorkTypes(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getCurrentWorkTypesPublic(token, type) {
      const data = {
        token,
        type
      };

      return (ApiService.getDetailWithParams(ApiUrl.getJAWorkTypesPublic, '', data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // TODO HERE if something necessary, for now just return data exactly from API
              this.setCurrentWorkTypes(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    // getSources() {
    //   return (ApiService.get(ApiUrl.getJASources).then(
    //     action(
    //       response => {
    //         if (response && response.status === 200 && response.data && !response.data.isError) {
    //           // TODO HERE if something necessary, for now just return data exactly from API
    //           this.setSources(response.data.result.items);
    //         } else {
    //           Alert.error("Oops, Something went wrong! Please try again.");
    //         }
    //         return Promise.resolve(response.data);
    //       }
    //     )
    //   ).catch(
    //     action(err => {
    //       return Promise.reject(err);
    //     })
    //   ));
    // },

    getRatings() {
      return (ApiService.get(ApiUrl.getJARatings).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // TODO HERE if something necessary, for now just return data exactly from API
              this.setRatings(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getRatingsPublic(token, type) {
      const data = {
        token,
        type
      };

      return (ApiService.getDetailWithParams(ApiUrl.getJARatingsPublic, '', data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // TODO HERE if something necessary, for now just return data exactly from API
              this.setRatings(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getCandidateCustomFields() {
      return (ApiService.get(ApiUrl.getCandidateCustomFields).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCandidateCustomFields(response.data.result);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getSalutations() {
      return (ApiService.get(ApiUrl.getJASalutations).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setSalutations(response.data.result.items || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getCandidateStatuses() {
      return (ApiService.get(ApiUrl.getJACandidateStatuses).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // TODO HERE if something necessary, for now just return data exactly from API

              let candidateStatusData = response.data.result.items;
              if (candidateStatusData.length > 0) {//Add 'Any' into dropdown options #8372
                candidateStatusData.unshift('Any');
              }
              //modify options candidate/client status, candidate/client note status, job sources #8372
              const candidateStatusOptions = candidateStatusData.map(option => {
                let data = option === 'Any' ? { name: option, statusId: 0 } : option;
                data.isDisabled = false;

                return data
              }) || [];

              this.setCandidateStatuses(candidateStatusOptions);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getCandidateNoteStatuses() {
      return (ApiService.get(ApiUrl.getJACandidateNoteStatuses).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // TODO HERE if something necessary, for now just return data exactly from API§§
              //modify options candidate note status #8372
              let candidateNoteStatusData = response.data.result.items;

              if (candidateNoteStatusData.length > 0) {//Add 'Any' into dropdown options #8372
                candidateNoteStatusData.unshift('Any');
              }

              const candidateNoteStatusOptions = candidateNoteStatusData.map(option => {
                let data = option === 'Any' ? { name: option } : option;
                data.isDisabled = false;

                return data
              }) || [];

              this.setCandidateNoteStatuses(candidateNoteStatusOptions);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getClientStatuses() {
      return (ApiService.get(ApiUrl.getJAClientStatuses).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // TODO HERE if something necessary, for now just return data exactly from API
              this.setClientStatuses(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getClientNoteStatuses() {
      return (ApiService.get(ApiUrl.getJAClientNoteStatuses).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // TODO HERE if something necessary, for now just return data exactly from API
              this.setClientNoteStatuses(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getClientCustomFields() {
      return (ApiService.get(ApiUrl.getClientCustomFields).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setClientCustomFields(response.data.result);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getPlacementCustomFields() {
      return (ApiService.get(ApiUrl.getPlacementCustomFields).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setPlacementCustomFields(response.data.result);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getJobCustomFields() {
      return (ApiService.get(ApiUrl.getJobCustomFields).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setJobCustomFields(response.data.result);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getApplicationCustomFields() {
      return (ApiService.get(ApiUrl.getApplicationCustomFields).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setApplicationCustomFields(response.data.result);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getEmailCampaignLink(emailCampaignId) {
      return (ApiService.get(ApiUrl.getEmailCampaignLinks + emailCampaignId).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              if(response.data.result && response.data.result.length > 0){
                this.setEmailCampaignLinks(response.data.result);
              }
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(
          error => {
            return Promise.reject(error);
          }
        )
      ));
    },

    getAllEmailCampaigns(automationType = AutomationType.Candidate) {
      return (ApiService.get(ApiUrl.getAllEmailCampaign + automationType).then(
        action(
          response => {
            this.setEmailTemplateList(response.data.result);
            if (automationType === AutomationType.Candidate) {
              this.setCandidateEmailTemplateList(response.data.result.filter(x => x.category && x.category.toLowerCase().includes(AutomationTypeText.Candidate.toLowerCase())));
            } else if (automationType === AutomationType.Client) {
              this.setClientEmailTemplateList(response.data.result.filter(x => x.category && x.category.toLowerCase().includes(AutomationTypeText.Contact.toLowerCase())));
            }
            return Promise.resolve(response);
          }
        )
      ).catch(
        action(
          error => {
            return Promise.reject(error);
          }
        )
      ));
    },

    getAllSurveys() {
      return (ApiService.get(ApiUrl.getAllSurveys).then(
        action(
          response => {
            this.setSurveyList(response.data.result)
            return Promise.resolve(response);
          }
        )
      ).catch(
        action(
          error => {
            return Promise.reject(error);
          }
        )
      ));
    },

    getAllSurveysWithDetails() {
      return (ApiService.get(ApiUrl.getListSurveys).then(
        action(
          response => {
            this.setSurveyListWithDetails(response.data.result)
            return Promise.resolve(response);
          }
        )
      ).catch(
        action(
          error => {
            return Promise.reject(error);
          }
        )
      ));
    },

    getAllForms(automationType = AutomationType.Candidate) {
      return (ApiService.get(ApiUrl.getAllForms + automationType).then(
        action(
          response => {
            this.setFormList(response.data.result)
            return Promise.resolve(response);
          }
        )
      ).catch(
        action(
          error => {
            return Promise.reject(error);
          }
        )
      ));
    },

    getActiveForms() {
      return (ApiService.get(ApiUrl.getActiveForms).then(
        action(
          response => {
            this.setActiveFormList(response.data.result)
            return Promise.resolve(response);
          }
        )
      ).catch(
        action(
          error => {
            return Promise.reject(error);
          }
        )
      ));
    },

    getTextCampaignList(type) {
      return (ApiService.getDetail(ApiUrl.getCampaignByType, type).then(
        action(
          response => {
            this.setTextCampaignList(response.data.result ?? [])
            return Promise.resolve(response.data.result);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getShortlinkByToken(contactType, token) {
      const apiUrlByType = contactType === Enum.ContactType.Candidate ? ApiUrl.getShortlinkByToken : ApiUrl.getShortlinkClientByToken;

      return (ApiService.getDetail(apiUrlByType, token).then(
        action(
          response => {

            const pattern = /^((http|https|ftp):\/\/)/;
            const actionPattern = /^((mailto|sms|tel):)/;
            let originalUrl = response.data.result.originalUrl

            // check if its an valid URL
            if (!pattern.test(originalUrl) && !actionPattern.test(originalUrl)) {
              originalUrl = "http://" + originalUrl;
            }
            if (pattern.test(originalUrl)) {
              const url = new URL(originalUrl)
              // add parameter to url
              url.searchParams.append('rid', response.data.result.token);
              url.searchParams.append('ridct', contactType);
              return Promise.resolve(url.href);
            }

            return Promise.resolve(originalUrl);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getCountries() {
      return (ApiService.get(ApiUrl.getJACountries).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCountries(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getCountriesPublic(token, type) {
      const data = {
        token,
        type
      };

      return (ApiService.getDetailWithParams(ApiUrl.getJACountriesPublic, '', data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCountries(response.data.result.items);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getTagSuggestionsWithParams(grid, type = null) {
      return (ApiService.getDetailWithParams(ApiUrl.getTagSuggestions, grid, { type }).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setTagSuggestions(response.data.result.map((item) => {
                return {
                  label: item,
                  value: item
                }
              }));
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(
          err => {
            return Promise.reject(err);
          }
        )
      ));
    },

    getTagSuggestions(type = null) {
      return (ApiService.getDetail(ApiUrl.getTagSuggestions, type).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setTagSuggestions(response.data.result.map((item) => {
                return {
                  label: item,
                  value: item
                }
              }));
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(
          err => {
            return Promise.reject(err);
          }
        )
      ));
    },

    getJobSources() {
      return (ApiService.get(ApiUrl.getJobApplicationSources).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // TODO HERE if something necessary, for now just return data exactly from API
              this.setJobSources(response.data.result);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getCustomFieldsPublic(token, type) {
      const data = {
        token,
        type
      };

      return (ApiService.getDetailWithParams(ApiUrl.getCustomFieldsPublic, '', data).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCustomFields(response.data.result);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => {
          return Promise.reject(err);
        })
      ));
    },

    getMultipleTriggerStatus(automationType) { // [NOTE] Change to multiple request to handle on stop the Promises before all resolve when each one is resolve
      const getActivityLogName = automationType === AutomationType.Candidate ? { url: ApiUrl.getActivityLogName } : { url: ApiUrl.getClientActivityLogName }
      const getNoteStatuses = automationType === AutomationType.Candidate ? { url: ApiUrl.getJACandidateNoteStatuses } : { url: ApiUrl.getJAClientNoteStatuses }
      const getStatuses = automationType === AutomationType.Candidate ? { url: ApiUrl.getJACandidateStatuses } : { url: ApiUrl.getJAClientStatuses }
      let param = [
        getStatuses,
        getNoteStatuses,
        { url: ApiUrl.getJobApplicationSources },
        getActivityLogName, // get link clicked title
        { url: ApiUrl.getPlacementStatuses },
        { url: ApiUrl.getApplicationStatuses },
        { url: ApiUrl.getJobStatuses },
        { url: ApiUrl.getJACountries },
        { url: ApiUrl.getCandidateSkillsHierarchy },
        { url: ApiUrl.getPlacementTypes },
        { url: ApiUrl.getInterviewTypes },
        { url: ApiUrl.getJAWorkTypes },
        { url: ApiUrl.getJobTypes },
        { url: ApiUrl.getCandidateAttachmentCategories },
        { url: ApiUrl.getCandidateAttachmentCategoriesDefaults }
      ];
      return (ApiService.multipleRequestAllSettled(param, '', Constants.ALERT_SOMETHING_WENT_WRONG).then(
        action(
          response => {
            let errorMessage = [];
            response.filter(x => x.status === "rejected").forEach((item) => {
              if (item && item.reason && item.reason.response && item.reason.response.data) {
                errorMessage = [...errorMessage, item.reason.response.data];
              }
            });

            if (errorMessage.length > 0) {
              errorMessage.forEach(item => {
                Alert.error(item);
              });
            }

            //modify options candidate/client status, candidate/client note status, job sources #8372
            let candidateOrClientStatusData = response[0].value?.data?.result?.items;
            let candidateOrClientNoteStatusData = response[1].value?.data?.result?.items;
            let jobSourceData = response[2].value?.data?.result;
            let placementStatusData = response[4].value?.data?.result;
            let applicationStatusData = response[5].value?.data?.result;
            let jobStatusData = response[6].value?.data?.result;

            // console.log('country:', toJS(response[7].value?.data?.result));
            let countriesData = response[7].value?.data?.result?.items;
            let candidateSkillsHierarchyData = response[8].value?.data?.result;
            let placementTypesData = response[9].value?.data?.result;
            let interviewTypesData = response[10].value?.data?.result;
            let workTypesData = response[11].value?.data?.result?.items;
            let jobTypesData = response[12].value?.data?.result;
            let candidateAttachmentCategoriesData = response[13].value?.data?.result;
            let candidateAttachmentCategoriesDefaultsData = response[14].value?.data?.result;

            if (candidateOrClientStatusData.length > 0) {//Add 'Any' into dropdown options #8372
              candidateOrClientStatusData.unshift({ statusId: 0, name: 'Any' });
            }
            if (candidateOrClientNoteStatusData.length > 0) {//Add 'Any' into dropdown options #8372
              candidateOrClientNoteStatusData.unshift({ name: 'Any' });
            }
            if (jobSourceData.length > 0) {//Add 'Any' into dropdown options #8372
              jobSourceData.unshift('Any');
            }
            if (placementStatusData.length > 0) {//Add 'Any' into dropdown options #8372
              placementStatusData.unshift({ statusId: 0, name: 'Any' });
            }
            if (applicationStatusData.length > 0) {
              //#8949 Add 'Any' into dropdown options
              applicationStatusData.unshift({ statusId: 0, name: 'Any' });
            }
            if (jobStatusData.length > 0) {
              // #8949 Add 'Any' into dropdown options
              jobStatusData.unshift({ statusId: 0, name: 'Any' });
            }

            if (countriesData.length > 0) {
              countriesData.unshift({ name: 'Any' });
            }

            //modify options candidate/client status, candidate/client note status, job sources #8372
            const candidateOrClientStatusOptions = candidateOrClientStatusData.map(option => {
              option.isDisabled = false;
              return option;
            }) || [];

            const candidateOrClientNoteStatusOptions = candidateOrClientNoteStatusData.map(option => {
              option.isDisabled = false;
              return option;
            }) || [];

            const placementStatusOption = placementStatusData.map(option => {
              option.isDisabled = false;
              return option;
            }) || [];

            const placementTypesOption = placementTypesData.map(option => {
              option.isDisabled = false;
              return option;
            }) || [];

            const interviewTypesOption = interviewTypesData.map(option => {
              option.isDisabled = false;
              return option;
            }) || [];

            const jobTypesOption = jobTypesData?.map(option => {
              option.isDisabled = false;
              return option;
            }) || [];

            const jobSourceOptions = jobSourceData.map(option => {
              let optionData = {};
              optionData.label = option;
              optionData.isDisabled = false;
              return optionData;
            })

            const applicationStatusOptions = applicationStatusData.map(option => {
              option.isDisabled = false;
              return option;
            }) || [];

            const jobStatusOptions = jobStatusData.map(option => {
              option.isDisabled = false;
              return option;
            }) || [];

            automationType === AutomationType.Candidate ?
              this.setCandidateStatuses(candidateOrClientStatusOptions || []) :
              this.setClientStatuses(candidateOrClientStatusOptions || []);
            automationType === AutomationType.Candidate ?
              this.setCandidateNoteStatuses(candidateOrClientNoteStatusOptions || []) :
              this.setClientNoteStatuses(candidateOrClientNoteStatusOptions || []);
            this.setJobSources(jobSourceOptions || []);
            this.setEmailLinkClickedList(response[3].value?.data?.result?.filter(x => x.activityLogType === 17) || []);
            this.setSmsLinkClickedList(response[3].value?.data?.result?.filter(x => x.activityLogType === 26) || []);
            this.setPlacementStatuses(placementStatusOption || []);
            this.setPlacementTypes(placementTypesOption || []);
            this.setInterviewTypes(interviewTypesOption || []);
            this.setJobTypes(jobTypesOption || []);
            this.setApplicationStatuses(applicationStatusOptions || []);
            this.setJobStatuses(jobStatusOptions || []);
            this.setCountries(countriesData || []);
            this.setCandidateSkillsHierarchy(candidateSkillsHierarchyData || []);
            this.setCurrentWorkTypes(workTypesData || []);
            this.setCandidateAttachmentCategories(candidateAttachmentCategoriesData || []);
            this.setCandidateAttachmentCategoriesDefaults(candidateAttachmentCategoriesDefaultsData);
            return Promise.resolve(response);
          }
        )
      ).catch(
        action(
          err => {
            return Promise.reject(err);
          }
        )
      ));
    },

    getActivityLogName() {
      const { automationType } = automationStore;
      const getActivityLogName = automationType === AutomationType.Candidate ? ApiUrl.getActivityLogName : ApiUrl.getClientActivityLogName
      return (ApiService.get(getActivityLogName).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setEmailLinkClickedList(response.data.result?.filter(x => x.activityLogType === 17) || []);
              this.setSmsLinkClickedList(response.data.result?.filter(x => x.activityLogType === 26) || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(
          err => {
            return Promise.reject(err);
          }
        )
      ));
    },

    getApplicationStatusesList() {
      return (ApiService.get(ApiUrl.getApplicationStatuses).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              const applicationStatusData = response.data.result;
              this.setApplicationStatuses(applicationStatusData || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }
            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(
          err => {
            return Promise.reject(err);
          }
        )
      ));
    },

    getCandidateAttachmentCategories() {
      return Promise.all([
        ApiService.get(ApiUrl.getCandidateAttachmentCategories),
        ApiService.get(ApiUrl.getCandidateAttachmentCategoriesDefaults),
      ]).then(
        action(([categoriesRes, defaultsRes]) => {
          if (categoriesRes && categoriesRes.status === 200 && categoriesRes.data && !categoriesRes.data.isError) {
            this.setCandidateAttachmentCategories(categoriesRes.data.result || []);
          } else {
            Alert.error("Oops, Something went wrong! Please try again.");
          }
          if (defaultsRes && defaultsRes.status === 200 && defaultsRes.data && !defaultsRes.data.isError) {
            this.setCandidateAttachmentCategoriesDefaults(defaultsRes.data.result);
          }
          return Promise.resolve(categoriesRes.data);
        })
      ).catch(
        action(err => Promise.reject(err))
      );
    },

    getContactAttachmentCategories() {
      return Promise.all([
        ApiService.get(ApiUrl.getContactAttachmentCategories),
        ApiService.get(ApiUrl.getContactAttachmentCategoriesDefaults),
      ]).then(
        action(([categoriesRes, defaultsRes]) => {
          if (categoriesRes && categoriesRes.status === 200 && categoriesRes.data && !categoriesRes.data.isError) {
            this.setContactAttachmentCategories(categoriesRes.data.result || []);
          } else {
            Alert.error("Oops, Something went wrong! Please try again.");
          }
          if (defaultsRes && defaultsRes.status === 200 && defaultsRes.data && !defaultsRes.data.isError) {
            this.setContactAttachmentCategoriesDefaults(defaultsRes.data.result);
          }
          return Promise.resolve(categoriesRes.data);
        })
      ).catch(
        action(err => Promise.reject(err))
      );
    },

    getPlacementStatusesList() {
      return (ApiService.get(ApiUrl.getPlacementStatuses).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setPlacementStatuses(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getJobStatusesList() {
      return (ApiService.get(ApiUrl.getJobStatuses).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setJobStatuses(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getPlacementTypesList() {
      // Return cached data immediately if available
      if (this.placementTypes.length > 0) {
        return Promise.resolve({ result: this.placementTypes });
      }

      return (ApiService.get(ApiUrl.getPlacementTypes).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setPlacementTypes(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getInterviewTypesList() {
      // Return cached data immediately if available
      if (this.interviewTypes.length > 0) {
        return Promise.resolve({ result: this.interviewTypes });
      }

      return (ApiService.get(ApiUrl.getInterviewTypes).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setInterviewTypes(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getJobTypesList() {
      // Return cached data immediately if available
      if (this.jobTypes.length > 0) {
        return Promise.resolve({ result: this.jobTypes });
      }

      return (ApiService.get(ApiUrl.getJobTypes).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setJobTypes(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getJobsList() {
      if (this.jobs.length > 0) {
        return Promise.resolve({ result: this.jobs });
      }

      return (ApiService.get(ApiUrl.getJobs).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              const jobsData = response.data.result || [];
              this.setJobs(jobsData);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getJobLocationsList() {
      if (this.jobLocations.length > 0) {
        return Promise.resolve({ result: this.jobLocations });
      }

      return (ApiService.get(ApiUrl.getJobLocations).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setJobLocations(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    // #region Candidate location/position fetchers
    getCandidateCurrentPositionsList() {
      if (this.candidateCurrentPositions.length > 0) {
        return Promise.resolve({ result: this.candidateCurrentPositions });
      }

      return (ApiService.get(ApiUrl.getCandidateCurrentPositions).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCandidateCurrentPositions(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getCandidateCurrentEmployersList() {
      if (this.candidateCurrentEmployers.length > 0) {
        return Promise.resolve({ result: this.candidateCurrentEmployers });
      }

      return (ApiService.get(ApiUrl.getCandidateCurrentEmployers).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCandidateCurrentEmployers(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getCandidatePostalCodesList() {
      if (this.candidatePostalCodes.length > 0) {
        return Promise.resolve({ result: this.candidatePostalCodes });
      }

      return (ApiService.get(ApiUrl.getCandidatePostalCodes).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCandidatePostalCodes(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getCandidateCitiesList() {
      if (this.candidateCities.length > 0) {
        return Promise.resolve({ result: this.candidateCities });
      }

      return (ApiService.get(ApiUrl.getCandidateCities).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCandidateCities(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getCandidateStatesList() {
      if (this.candidateStates.length > 0) {
        return Promise.resolve({ result: this.candidateStates });
      }

      return (ApiService.get(ApiUrl.getCandidateStates).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCandidateStates(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getCandidateSourcesList() {
      if (this.candidateSources.length > 0) {
        return Promise.resolve({ result: this.candidateSources });
      }

      return (ApiService.get(ApiUrl.getCandidateSources).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCandidateSources((response.data.result && response.data.result.items) || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getCandidateContactMethodsList() {
      if (this.candidateContactMethods.length > 0) {
        return Promise.resolve({ result: this.candidateContactMethods });
      }

      return (ApiService.get(ApiUrl.getCandidateContactMethods).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setCandidateContactMethods(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getClientPositionsList() {
      if (this.clientPositions.length > 0) {
        return Promise.resolve({ result: this.clientPositions });
      }

      return (ApiService.get(ApiUrl.getClientPositions).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setClientPositions(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getClientCitiesList() {
      if (this.clientCities.length > 0) {
        return Promise.resolve({ result: this.clientCities });
      }

      return (ApiService.get(ApiUrl.getClientCities).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setClientCities(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getClientStatesList() {
      if (this.clientStates.length > 0) {
        return Promise.resolve({ result: this.clientStates });
      }

      return (ApiService.get(ApiUrl.getClientStates).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setClientStates(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getClientPostalCodesList() {
      if (this.clientPostalCodes.length > 0) {
        return Promise.resolve({ result: this.clientPostalCodes });
      }

      return (ApiService.get(ApiUrl.getClientPostalCodes).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              this.setClientPostalCodes(response.data.result || []);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getClientCountriesList() {
      if (this.clientCountries.length > 0) {
        return Promise.resolve({ result: this.clientCountries });
      }

      return (ApiService.get(ApiUrl.getJACountries).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // Map the countries to extract just the name property
              const countryNames = (response.data.result.items || []).map(country => country.name);
              this.setClientCountries(countryNames);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },

    getClientCompaniesList() {
      if (this.clientCompanies.length > 0) {
        return Promise.resolve({ result: this.clientCompanies });
      }

      return (ApiService.get(ApiUrl.getCompanies).then(
        action(
          response => {
            if (response && response.status === 200 && response.data && !response.data.isError) {
              // Map the companies to extract just the name property
              const companyNames = (response.data.result || []).map(company => company.name);
              this.setClientCompanies(companyNames);
            } else {
              Alert.error("Oops, Something went wrong! Please try again.");
            }

            return Promise.resolve(response.data);
          }
        )
      ).catch(
        action(err => Promise.reject(err))
      ));
    },
    // #endregion

    // #region Skills fetchers
    getSkillCategories: () => ApiService.get(ApiUrl.getSkillCategories).then(
      action(response => {
        if (response && response.status === 200 && response.data && !response.data.isError) {
          lookupStore.setSkillCategories(response.data);
        } else {
          Alert.error("Oops, Something went wrong! Please try again.");
        }

        return Promise.resolve(response.data);
      })
    ).catch(
      action(err => Promise.reject(err))
    ),

    getSkillSubCategories: () => ApiService.get(ApiUrl.getSkillSubCategories).then(
      action(response => {
        if (response && response.status === 200 && response.data && !response.data.isError) {
          lookupStore.setSkillSubCategories(response.data);
        } else {
          Alert.error("Oops, Something went wrong! Please try again.");
        }

        return Promise.resolve(response.data);
      })
    ).catch(
      action(err => Promise.reject(err))
    ),

    getSkills: () => ApiService.get(ApiUrl.getSkills).then(
      action(response => {
        if (response && response.status === 200 && response.data && !response.data.isError) {
          lookupStore.setSkills(response.data);
        } else {
          Alert.error("Oops, Something went wrong! Please try again.");
        }

        return Promise.resolve(response.data);
      })
    ).catch(
      action(err => Promise.reject(err))
    ),
    // #endregion


    getBeeFreeAuthToken: (hashCompanyId) => ApiService.post(ApiUrl.getBeeAuthToken, {uid:hashCompanyId}).then(
      action(response => {
        if (response && response.data && response.data.statusCode === 200) {
          return Promise.resolve(response.data.result);
        } else {
          return Promise.reject(response.data.error);
        }
      })
    ),

    getBeeFreeFileManagerAuthToken: (hashCompanyId) => ApiService.post(ApiUrl.getBeeFileManagerAuthToken, {uid:hashCompanyId}).then(
      action(response => {
        if (response && response.data && response.data.statusCode === 200) {
          return Promise.resolve(response.data.result);
        } else {
          return Promise.reject(response.data.error);
        }
      })
    ),

    getBeeFreePageBuilderAuthToken: (hashCompanyId) => ApiService.post(ApiUrl.getBeePageBuilderAuthToken, {uid:hashCompanyId}).then(
      action(response => {
        if (response && response.data && response.data.statusCode === 200) {
          return Promise.resolve(response.data.result);
        } else {
          return Promise.reject(response.data.error);
        }
      })
    ),

    importBeeHtml: (html) => ApiService.post(ApiUrl.beeHtmlImport, { html }).then(
      action(response => {
        if (response && response.data && response.data.statusCode === 200) {
          return Promise.resolve(response.data.result);
        } else {
          return Promise.reject(response.data.error);
        }
      })
    )
  }
);

export default lookupStore;
